import React from 'react';
import { Icon } from './Icon.js';
export const IconChartPie3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M10.5 22C5.80558 22 2 18.1945 2 13.5C2 8.97343 5.53831 5.27327 10 5.01447V14H18.9855C18.7267 18.4617 15.0266 22 10.5 22Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 10C22 5.58172 18.4183 2 14 2V10H22Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChartPie3.js.map